var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"card-text-alignment"}},[_c('section',{attrs:{"id":"search-section"}},[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-card',[_c('Search')],1)],1)],1)],1),_c('StockEntryList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }